import { createAction, props } from "@ngrx/store";

export const getAccessToken = createAction(
    '[GetAccessToken]', props<{ accessToken: string }>()
)

export const setAccessToken = createAction(
    '[SetAccessToken]', props<{ accessToken: string ; refreshToken: string }>()
)
